import Vue from 'vue'
import Router from 'vue-router'
import HomePage from "./home/HomePage";
import { NotFoundPage } from "./shared/components";
import { scheduleRoutes } from './schedule';
import { paymentRoutes } from "./payment";
import {orderRoutes} from "./orders";
import About from "./about/About";
import Contact from "./contact/Contact";

Vue.use(Router);

const appRoutes = [
    {
        path: '/',
        name: 'home',
        component: HomePage,
        meta: {
            title: 'Viso Car'
        }
    },
    {
        path: '/gioi-thieu',
        name: 'about',
        component: About,
        meta: {
            title: 'Viso Car'
        }
    },
    {
        path: '/lien-he',
        name: 'contact',
        component: Contact,
        meta: {
            title: 'Viso Car'
        }
    },
    {
        path: '*',
        name: 'not-found',
        component: NotFoundPage,
        meta: {
            title: 'Viso Car',
        }
    }
];

const routes = [...scheduleRoutes, ...paymentRoutes, ...orderRoutes, ...appRoutes];
const router = new Router({
    mode: 'history',
    routes
});

export default router;
